import React from "react";
import _ from "underscore";
import { LinkButton } from "../../../../core/atoms/atoms";
import { CardContainer } from "../../../../shared/components/inspiration/cardContainer";
import { CollectionKeyHelper } from "../../../../shared/helpers/contentCollectionHelpers";
import ResponsiveContainer from "../../../../shared/helpers/responsiveContainer";
import * as WebRoutes from "@travellocal/utils/webRoutes";
import { SwipeCarousel } from "../../swipeCarousel/swipeCarousel";

import "./tripIdeas.scss";

export const HomeTripIdeas = () => {
  return (
    <section className="home-trip-ideas width-wrapper home__section">
      <div className="columns is-centered is-mobile is-marginless">
        <div className="home-trip-ideas__copy column is-full-mobile is-10-tablet is-7-desktop is-paddingless">
          <h2>Trip ideas to get you started</h2>
          <p className="text--regular">
            Here are just a few of the great trip ideas that our local experts have created to inspire you.
            Personalise an idea to your heart’s content or have your holiday tailor-made from scratch.
              </p>
        </div>
      </div>

      <ResponsiveContainer
        mobile={() => (
          <CardContainer
            className="home-trip-ideas__cards home-trip-ideas__cards--mobile"
            collectionKey={CollectionKeyHelper.HomeItineraries}
            filters={{ types: [ContentType.SampleItinerary] }}
            renderCardWrapper={elements => (
              <SwipeCarousel nextLabel="More ideas">{elements}</SwipeCarousel>
            )}
          />
        )}
        tablet={() => (
          <CardContainer
            className="home-trip-ideas__cards home-trip-ideas__cards--desktop is-marginless"
            collectionKey={CollectionKeyHelper.HomeItineraries}
            cardLimit={4}
            filters={{ types: [ContentType.SampleItinerary] }}
            columnClassName="column is-6-tablet is-4-desktop is-3-widescreen"
            isMultineColumn={false}
          />
        )}
      />

      <div className="columns is-centered is-mobile is-marginless">
        <LinkButton
          className="primary-button heading--4 text--light"
          to={WebRoutes.inspiration({ types: [ContentType.SampleItinerary] })}
        >
          See more holiday ideas
          </LinkButton>
      </div>
    </section>
  );
}
